<h1 mat-dialog-title class="p-2 text-center" i18n>Selectionnez le groupe de destination </h1>
<div mat-dialog-content class="p-3">

    <div class="row align-items-center">
        <mat-form-field appearance="fill">
            <mat-select [(ngModel)]="SelectedGroup" name="configuration">
                @for (group of TestGroupList; track group.Code) {
                <mat-option [value]="group">
                    {{group.Name}}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1 white" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()" i18n>
            Appliquer
        </button>
    </div>
</div>